import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var HouseUser = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 576 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M570.69 236.27 512 184.44V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v51.67L314.78 10.3C308.5 4.61 296.53 0 288 0s-20.46 4.61-26.74 10.3l-256 226A18.27 18.27 0 0 0 0 248.2a18.64 18.64 0 0 0 4.09 10.71L25.5 282.7a21.14 21.14 0 0 0 12 5.3 21.67 21.67 0 0 0 10.69-4.11l15.9-14V480a32 32 0 0 0 32 32H480a32 32 0 0 0 32-32V269.88l15.91 14a21.94 21.94 0 0 0 10.72 4.12 20.89 20.89 0 0 0 11.87-5.31l21.41-23.81a21.64 21.64 0 0 0 4.09-10.69 21 21 0 0 0-5.31-11.92zM288 176a64 64 0 1 1-64 64 64 64 0 0 1 64-64zm112 272H176a16 16 0 0 1-16-16 96 96 0 0 1 96-96h64a96 96 0 0 1 96 96 16 16 0 0 1-16 16z"
  }));
});
HouseUser.displayName = 'HouseUser';
export var HouseUserDimensions = {
  height: 512,
  width: 576
};